export default __webpack_public_path__ + "static/media/ic_top-2.d5801a47.svg";